export default "__VITE_ASSET__CJOs_OJV__"